module.exports = __webpack_public_path__ + "static/media/3.7454ff3b.PNG";